export const delay = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const fillArray = <T>(n: number, f: () => T): Array<T> => (
  Array.apply(null, Array(n)).map(() => f())
)



// WEBPACK FOOTER //
// ./src/common/util.ts